import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Expertise from '../components/Expertise';
import Career from '../components/Career';
import ThoughtLeadership from '../components/ThoughtLeadership';
import Contact from '../components/Contact';

const Home = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <Hero />
      <Expertise />
      <Career />
      <ThoughtLeadership />
      <Contact />
    </div>
  );
};

export default Home;